module.exports = __webpack_public_path__ + "img/CC0000_default.cbc36688.png";